import { useEffect, useState } from "react";
import { useParams, Link, useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { CertificateCard } from "@/components/CertificateCard";
import { Printer, ArrowLeft } from "@phosphor-icons/react";

export default function AdminCertificate() {
  const { userId, packageId } = useParams();
  const navigate = useNavigate();
  const [data, setData] = useState(null);
  const [error, setError] = useState(false);

  useEffect(() => {
    api.get(`/admin/certificate/${userId}/${packageId}`)
      .then((r) => setData(r.data))
      .catch(() => setError(true));
  }, [userId, packageId]);

  if (error) {
    return (
      <div className="max-w-2xl mx-auto px-6 py-24 text-center" data-testid="admin-cert-error">
        <h1 className="font-heading font-bold text-2xl text-ink">Certificate unavailable</h1>
        <Button onClick={() => navigate("/admin")} className="mt-6 rounded-full">Back to admin</Button>
      </div>
    );
  }
  if (!data) return <div className="min-h-[60vh] grid place-items-center font-body text-ink-soft">Loading…</div>;

  const certDate = data.certified_at
    ? new Date(data.certified_at).toLocaleDateString(undefined, { year: "numeric", month: "long", day: "numeric" })
    : undefined;

  return (
    <div className="max-w-4xl mx-auto px-4 sm:px-6 py-10" data-testid="admin-certificate-page">
      <div className="flex items-center justify-between mb-6 no-print">
        <Link to="/admin" className="inline-flex items-center gap-2 font-body font-semibold text-ink-soft hover:text-brand-sky">
          <ArrowLeft size={18} weight="bold" /> Back to admin
        </Link>
        <Button onClick={() => window.print()} className="rounded-full bg-brand-sky hover:bg-brand-skylight text-white font-bold px-6" data-testid="admin-print-certificate-btn">
          <Printer size={20} weight="duotone" className="mr-2" /> Print / Save PDF
        </Button>
      </div>
      <CertificateCard
        name={data.name}
        packageTitle={data.package_title}
        level={data.level}
        color={data.color}
        date={certDate}
      />
    </div>
  );
}
